
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IContactCustomFields, IContactCustomFieldsForDropdown, IUpdateCustomContactFields } from '@shared/services/api/legacy/contactcustomfields-service/contactcustomfields-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class ContactCustomFieldsService {

  constructor(private http: HttpClient) { }

  private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${ContactCustomFieldsService.ENDPOINT}`; }
  private static readonly ENDPOINT = '/contactcustomfields';

  public getContactCustomFields(): Observable<SuccessResponse<IContactCustomFields> | ErrorResponse> {
    return this.http
    .get<SuccessResponse<IContactCustomFields>>(ContactCustomFieldsService.URL).pipe(
    catchError(error => observableOf(new ErrorResponse(error.error))));
  }

  public getContactCustomFieldsForDropdown(): Observable<SuccessResponse<IContactCustomFieldsForDropdown> | ErrorResponse>  {
    return this.http
      .get<SuccessResponse<IContactCustomFieldsForDropdown>>(ContactCustomFieldsService.URL + '/dropdown').pipe(
      catchError(error => observableOf(new ErrorResponse(error.error))));
  }

  public getContactCustomFieldsForImportDropdown(): Observable<SuccessResponse<IContactCustomFieldsForDropdown> | ErrorResponse>  {
    return this.http
      .get<SuccessResponse<IContactCustomFieldsForDropdown>>(ContactCustomFieldsService.URL + '/dropdown/imports').pipe(
      catchError(error => observableOf(new ErrorResponse(error.error))));
  }

  public updateContactCustomFields(submitData: IUpdateCustomContactFields): Observable<SuccessResponse<boolean> | ErrorResponse> {
    return this.http
    .put<SuccessResponse<boolean>>(ContactCustomFieldsService.URL, submitData).pipe(
    catchError(error => observableOf(new ErrorResponse(error.error))));
  }

}
